import {
  DateRangeFilter,
  dateBetweenFilterFn,
} from "../../../../components/tables/DateRangeFilter";

const tableColumns = [
  {
    Header: "Shipment Rack ID",
    accessor: "shipmentRackId",
  },
  {
    Header: "Total Items On Rack",
    accessor: "totalRackItems",
    disableSortBy: true,
    disableFilters: true,
  },
  {
    Header: "Status",
    accessor: "shipmentRackStatusId",
    Cell: ({ row }) => {
      return row.original.shipmentRackStatus;
    },
  },
  {
    Header: "Updated",
    accessor: "lastUpdated",
    Cell: ({ value }) => {
      return new Date(value).toDateString();
    },
    Filter: DateRangeFilter,
    filter: dateBetweenFilterFn,
  },
];

export default tableColumns;
